// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__03K+P","comprules":"faq_comprules__j9bc+","rulebutton":"faq_rulebutton__Yn23G"};